import { validateEnumTranslations } from '../../safety_checks';
import { Subcription } from '../namespace';

/**
 * Taglines marketing des plans v2 (Starter / Pro / Max).
 *
 * La clé de traduction est référencée par `PLANS[*].tagline_translation_key` dans
 * `subscription.ts`. Ce namespace centralise les libellés et garantit (via
 * `validateEnumTranslations`) qu'un nouveau plan ajouté à l'enum `Subcription`
 * sans tagline déclarée casse la build.
 */
export const TRANSLATE_KEY_PLAN_TAGLINE_PREFIX = 'PLAN_';
export const TRANSLATE_KEY_PLAN_TAGLINE_SUFFIX = '_TAGLINE';

const buildKey = (label: Subcription): string =>
  `${TRANSLATE_KEY_PLAN_TAGLINE_PREFIX}${label}${TRANSLATE_KEY_PLAN_TAGLINE_SUFFIX}`;

export const PLAN_TAGLINE_KEY_BY_LABEL: Record<Subcription, string> = {
  [Subcription.STARTER]: buildKey(Subcription.STARTER),
  [Subcription.PRO]: buildKey(Subcription.PRO),
  [Subcription.MAX]: buildKey(Subcription.MAX),
};

export const PlanTaglineTranslation = {
  'fr-FR': {
    [PLAN_TAGLINE_KEY_BY_LABEL[Subcription.STARTER]]: 'Pour digitaliser votre prise de rendez-vous.',
    [PLAN_TAGLINE_KEY_BY_LABEL[Subcription.PRO]]: 'Pour passer à la vitesse supérieure.',
    [PLAN_TAGLINE_KEY_BY_LABEL[Subcription.MAX]]: 'Pour automatiser et booster votre croissance.',
  },
};

//DONT TOUCH below this line
// `validateEnumTranslations` veut un prefixe unique : on lui passe le préfixe complet
// reconstruit pour matcher les clés (PLAN_STARTER_TAGLINE etc.).
const enumForValidation = {
  [Subcription.STARTER]: `${Subcription.STARTER}${TRANSLATE_KEY_PLAN_TAGLINE_SUFFIX}`,
  [Subcription.PRO]: `${Subcription.PRO}${TRANSLATE_KEY_PLAN_TAGLINE_SUFFIX}`,
  [Subcription.MAX]: `${Subcription.MAX}${TRANSLATE_KEY_PLAN_TAGLINE_SUFFIX}`,
};
validateEnumTranslations(enumForValidation, PlanTaglineTranslation, TRANSLATE_KEY_PLAN_TAGLINE_PREFIX, true);
